export const searchFields = ["occupation", "location", "companyName", "name"];
